import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleEmail, PurplePhone } from 'Images';

interface IMoreContactDetails {
  homePhoneNumber: string | null;
  email: string;
}

export const MoreContactDetails = ({
  email,
  homePhoneNumber,
}: IMoreContactDetails) => {
  const isDesktop = useIsDesktop();

  if (!email && !homePhoneNumber) return null;

  return (
    <Stack
      gap='8px'
      sx={{
        width: '100%',
        maxWidth: '307px',
        cursor: 'text',
      }}
    >
      <Typography variant='body5' component='h4'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.moreContactDetails}
      </Typography>
      <Stack>
        {homePhoneNumber && (
          <Stack
            direction='row'
            alignItems='center'
            gap='8px'
            onClick={
              isDesktop
                ? undefined
                : () => (window.location.href = `tel:${homePhoneNumber}`)
            }
          >
            <Avatar
              alt=''
              src={PurplePhone}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body3'>{homePhoneNumber}</Typography>
          </Stack>
        )}
        {email && (
          <Stack
            direction='row'
            alignItems='center'
            gap='8px'
            sx={{
              width: 'fit-content',
              ':hover': {
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            }}
            onClick={() => (window.location.href = `mailto:${email}`)}
          >
            <Avatar
              alt=''
              src={PurpleEmail}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body3'>{email.toLocaleLowerCase()}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
